import axios, { AxiosInstance } from 'axios'
import ApiError from '../../entities/api-error/ApiError'
import { store } from '../store'
import { AuthAction } from '../store/actions/auth/AuthAction'
import { logout } from '../store/actions/auth/Logout'

export interface IApiConfig {
  apiUrl?: string
}
export class Api {
  client: AxiosInstance

  constructor(config: IApiConfig) {
    if (!config.apiUrl) {
      throw new Error('apiUrl cannot be empty')
    }

    this.client = axios.create({
      baseURL: config.apiUrl,
    })

    this._setup()
  }

  protected _setup() {
    this.client.interceptors.request.use(async request => {
      return request
    })

    this.client.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          store.dispatch<AuthAction>(logout())
        }

        // TODO replace with translation
        // const networkFallbackMessage = intlProvider.intl.formatMessage(messages.networkError, { appName: config.appName})
        const networkFallbackMessage = 'Network error'
        const status = (error.response && error.response.status) ? error.response.status : 0
        const message = error.response?.data?.message || error.message

        const httpError = new ApiError({
          message: status === 0 ? networkFallbackMessage : message,
          status,
        })

        return Promise.reject(httpError)
      }
    )
  }
}

export const api = new Api({
  apiUrl: process.env.REACT_APP_API_URL,
})
